
// Environment detection utilities

/**
 * Represents the possible environments the app can run in.
 */
export type Environment = 'local' | 'development' | 'staging' | 'production';

/**
 * Configuration options for each environment.
 */
export interface EnvironmentConfig {
  // The base URL for the site
  siteUrl: string;
  // API base URL
  apiUrl: string;
  // Environment name
  name: Environment;
}

/**
 * Available environments and their configurations.
 */
const ENVIRONMENTS: Record<Environment, EnvironmentConfig> = {
  local: {
    siteUrl: 'http://localhost:3000',
    apiUrl: 'http://localhost:54321',
    name: 'local',
  },
  development: {
    siteUrl: 'https://app.leadextract.io',
    apiUrl: 'https://embqetqnbgbpzkekvuhi.supabase.co',
    name: 'development',
  },
  staging: {
    siteUrl: 'https://app.leadextract.io',
    apiUrl: 'https://embqetqnbgbpzkekvuhi.supabase.co',
    name: 'staging',
  },
  production: {
    siteUrl: 'https://app.leadextract.io',
    apiUrl: 'https://embqetqnbgbpzkekvuhi.supabase.co',
    name: 'production',
  },
};

/**
 * Detects the current environment based on the URL.
 * 
 * @returns The detected environment.
 */
export const detectEnvironment = (): Environment => {
  const url = window.location.href.toLowerCase();
  
  if (url.includes('localhost') || url.includes('127.0.0.1')) {
    return 'local';
  }
  
  if (url.includes('dev') || url.includes('development')) {
    return 'development';
  }
  
  if (url.includes('staging') || url.includes('stg')) {
    return 'staging';
  }
  
  return 'production';
};

/**
 * Gets the configuration for a specific environment.
 * 
 * @param env The environment to get the configuration for.
 * @returns The configuration for the specified environment.
 */
export const getEnvironmentConfig = (env: Environment): EnvironmentConfig => {
  return ENVIRONMENTS[env];
};
